import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { DefaultMapping, Unit } from '@synergy/models';

export class UnitApi {
    constructor(protected baseUrl: string) {}

    public cget(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Unit>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/units`, { params }),
            response => response.data
        );
    }

    public updateDefaultMapping = async (mapping: DefaultMapping): Promise<ApiResult<DefaultMapping<Unit>>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/units/${mapping.id}/mapping`, {
                    defaultMapping: mapping.defaultMapping,
                }),
            response => response.data
        );
    };

    public createUnit = async (unit: Partial<Unit>): Promise<ApiResult<Unit>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/units`, unit),
            response => response.data
        );
    };

    public getDefaultMapping(
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<DefaultMapping<Unit>>>> {
        return safeRequest(
            () => request.get<PaginatedResponse<DefaultMapping<Unit>>>(`${this.baseUrl}/units/mapping`, { params }),
            response => {
                return response.data;
            }
        );
    }

    public update = async (unit: Partial<Unit>): Promise<ApiResult<Unit>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/units/${unit.id}`, unit),
            response => response.data
        );
    };

    public delete = async (unitId: number): Promise<ApiResult<Unit>> => {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/units/${unitId}`),
            response => response.data
        );
    };
}
